// @flow
import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../../components/Section";
import { updateField } from "../../../../redux/actions/configActions";
import ImageField from "../../../components/ImageField";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class MosaicSettings extends React.Component {
  constructor(props) {
    super(props);

    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleValidatedFileChange = this.handleValidatedFileChange.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config, files } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }

  handleValidatedFileChange(id, image) {
    this.props.updateField({ [id]: image });
  }

  // #endregion
  render() {
    const { config, files } = this.props;
    return (
      <React.Fragment>
        <Section title="Mosaic settings" subsection>
          <FormGroup row>
            <Label for="columns" sm={2}>
              {" "}
              Number of columns{" "}
            </Label>
            <Col sm={10}>
              <Input
                value={config.columns}
                type="number"
                name="columns"
                id="columns"
                onChange={this.handleChange}
                required={config.setting === "1"}
                min="1"
                max="99"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <ImageField
              id="mosaicImage"
              label="Mosaic image"
              required
              image={files.mosaicImageFile}
              onDeleteChange={this.handleCheckboxChange}
              onFileChange={this.handleValidatedFileChange}
            />
          </FormGroup>
        </Section>
      </React.Fragment>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MosaicSettings);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/config-form-subsections/MosaicSettings.jsx